import { connect } from 'react-redux';
import ModalIdMappingComponent from './modal-id-mapping-component';
import { close, uploadFile, setFileValue, setFileType } from './redux/actions';

const mapStateToProps = (state: any) => ({
  isActive: state.management.idMapping.modal.active,
  title: state.management.idMapping.modal.title,
  content: state.management.idMapping.modal.content,
  execute: state.management.idMapping.modal.execute,
  disabledUpload: state.management.idMapping.modal.disabledUpload,
  dataUpload: state.management.idMapping.modal.dataUpload,
  fileNameToUpload: state.management.idMapping.modal.fileNameToUpload,
  fileType: state.management.idMapping.modal.fileType,
  ingestType: state.management.idMapping.modal.ingestType,
  t: state.i18n.t
});

export default connect(mapStateToProps, {
  close,
  uploadFile,
  setFileValue,
  setFileType
})(ModalIdMappingComponent);
